import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Col, Row, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getImageURL } from "../util/images";
import { fetchNewsAsync } from "../features/news/newsSlice";

export default function NewsItems() {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.news.news);
    const status = useSelector((state) => state.news.status);
    const error = useSelector((state) => state.news.error);

    useEffect(() => {
        if (status === "idle") {
            dispatch(fetchNewsAsync());
        }
    }, [dispatch, status]);

    if (status === "pending") return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    return (
        <Row gutter={[20, 20]}>
            {data.length === 0 && <div className="AlertInfo">No news found</div>}
            {data?.map((news) => (
                <Col key={news.id} md={8}>
                    <Link to={`/news/${news.id}`}>
                        <Card
                            hoverable
                            bordered={false}
                            className="CardItem"
                            cover={<img alt="" src={getImageURL(news.attributes?.Cover?.data?.attributes?.url)} />}
                        >
                            <h3>{news.attributes.Title}</h3>
                            <p>{news.attributes.Summary}</p>
                            <div className="CardMeta">
                                <time>
                                    {new Date(news.attributes.publishedDate).toLocaleDateString("en-gb", {
                                        day: "numeric",
                                        month: "long",
                                        year: "numeric",
                                        hour: "2-digit",
                                        minute: "2-digit",
                                        hour12: true,
                                    })}
                                </time>
                            </div>
                        </Card>
                    </Link>
                </Col>
            ))}
        </Row>
    );
}
